import { SxProps, Theme } from '@mui/material';

export const buttonContainerSX: SxProps<Theme> = {
	display: 'flex',
    justifyContent: {
        xs: 'center',
        md: 'start',
    },
};
